import { REQUEST, SUCCESS, FAILURE } from '@/plugins/store'

export default {
  // get list campaign
  GET_LIST_CAMPAIGN_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_CAMPAIGN_SUCCESS(state, data) {
    SUCCESS(state)
    state.listCampaign = data
  },
  GET_LIST_CAMPAIGN_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list Ad group
  GET_LIST_AD_GROUP_SPP_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_AD_GROUP_SPP_SUCCESS(state, data) {
    SUCCESS(state)
    state.listAdGroupSpp = data
  },
  GET_LIST_AD_GROUP_SPP_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list Ad
  GET_LIST_AD_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_AD_SUCCESS(state, data) {
    SUCCESS(state)
    state.listAd = data
  },
  GET_LIST_AD_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list campaign detail
  GET_LIST_CAMPAIGN_DETAIL_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_CAMPAIGN_DETAIL_SUCCESS(state, data) {
    SUCCESS(state)
    state.campaignDetail = data
  },
  GET_LIST_CAMPAIGN_DETAIL_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list Ad group of Campaign
  GET_LIST_AD_GROUP_CAMPAIGN_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_AD_GROUP_CAMPAIGN_SUCCESS(state, data) {
    SUCCESS(state)
    state.listAdGroupCampaign = data
  },
  GET_LIST_AD_GROUP_CAMPAIGN_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list Ad S++ of campaign
  GET_LIST_AD_CAMPAIGN_SPP_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_AD_CAMPAIGN_SPP_SUCCESS(state, data) {
    SUCCESS(state)
    state.listAdCampaignSpp = data
  },
  GET_LIST_AD_CAMPAIGN_SPP_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list Ad S+ of campaign
  GET_LIST_AD_CAMPAIGN_SP_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_AD_CAMPAIGN_SP_SUCCESS(state, data) {
    SUCCESS(state)
    state.listAdCampaignSp = data
  },
  GET_LIST_AD_CAMPAIGN_SP_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list ad manual of campaign
  GET_LIST_AD_CAMPAIGN_MANUAL_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_AD_CAMPAIGN_MANUAL_SUCCESS(state, data) {
    SUCCESS(state)
    state.listAdCampaignManual = data
  },
  GET_LIST_AD_CAMPAIGN_MANUAL_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list Identity
  GET_LIST_IDENTITY_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_IDENTITY_SUCCESS(state, data) {
    SUCCESS(state)
    state.listIdentity = data
  },
  GET_LIST_IDENTITY_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list Video TikTok of Identity
  GET_LIST_VIDEO_TIKTOK_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_VIDEO_TIKTOK_SUCCESS(state, data) {
    SUCCESS(state)
    state.listVideoTikTok = data
  },
  GET_LIST_VIDEO_TIKTOK_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list Video TikTok of Creative library
  GET_LIST_VIDEO_CREATIVE_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_VIDEO_CREATIVE_SUCCESS(state, data) {
    SUCCESS(state)
    state.listVideoCreative = data
  },
  GET_LIST_VIDEO_CREATIVE_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list thumbnail of  Video TikTok Creative library
  GET_THUMBNAIL_VIDEO_CREATIVE_REQUEST(state) {
    REQUEST(state)
  },
  GET_THUMBNAIL_VIDEO_CREATIVE_SUCCESS(state, data) {
    SUCCESS(state)
    state.listThumbnailVideoCreative = data
  },
  GET_THUMBNAIL_VIDEO_CREATIVE_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list Video Library
  GET_LIST_VIDEO_LIBRARY_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_VIDEO_LIBRARY_SUCCESS(state, data) {
    SUCCESS(state)
    state.listVideoLibrary = data
  },
  GET_LIST_VIDEO_LIBRARY_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // Sync video to ad account
  SYNC_VIDEO_TO_AD_ACCOUNT_REQUEST(state) {
    REQUEST(state)
  },
  SYNC_VIDEO_TO_AD_ACCOUNT_SUCCESS(state, data) {
    SUCCESS(state)
    state.videoSyncInfo = data
  },
  SYNC_VIDEO_TO_AD_ACCOUNT_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // duplicate campaign
  DUPLICATE_CAMPAIGN_REQUEST(state) {
    REQUEST(state)
  },
  DUPLICATE_CAMPAIGN_SUCCESS(state) {
    SUCCESS(state)
  },
  DUPLICATE_CAMPAIGN_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // update status campaign
  UPDATE_STATUS_CAMPAIGN_REQUEST(state) {
    REQUEST(state)
  },
  UPDATE_STATUS_CAMPAIGN_SUCCESS(state) {
    SUCCESS(state)
  },
  UPDATE_STATUS_CAMPAIGN_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // update status ad group
  UPDATE_STATUS_AD_GROUP_REQUEST(state) {
    REQUEST(state)
  },
  UPDATE_STATUS_AD_GROUP_SUCCESS(state) {
    SUCCESS(state)
  },
  UPDATE_STATUS_AD_GROUP_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // update status ad
  UPDATE_STATUS_AD_REQUEST(state) {
    REQUEST(state)
  },
  UPDATE_STATUS_AD_SUCCESS(state) {
    SUCCESS(state)
  },
  UPDATE_STATUS_AD_FAILURE(state, error) {
    FAILURE(state, error)
  },

  // get list Location
  GET_LIST_LOCATION_REQUEST(state) {
    REQUEST(state)
  },
  GET_LIST_LOCATION_SUCCESS(state, data) {
    SUCCESS(state)
    state.listLocation = data
  },
  GET_LIST_LOCATION_FAILURE(state, error) {
    FAILURE(state, error)
  },
}
